import React, { Component } from 'react';
import { Example, Properties, SourceCode, Tip } from 'examples';
import Group from '../Group/Group';
import Select from './Select';
import Tree from '../Tree/Tree';
import Application from '../Application/Application';

function createItems(start = 0, size = 25) {
  const items = [];

  for (let j = start; j < start + size; j++) {
    const subItem = {
      id: `id-${j}`,
      title: `Folder ${j + 1}`,
      description: `Folder with ${size} items`,
      children: [],
    };

    for (let k = 0; k < size; k++) {
      subItem.children.push({
        id: `id-${j + j}`,
        title: `Folder ${j + 1}.${k + 1}`,
        description: 'Empty folder',
      });
    }
    items.push(subItem);
  }
  return items;
}

const ITEMS = createItems();

export default class SelectExample extends Component {

  state = {
    options: [{
      label: 'Option 1',
      value: 1,
      children: [{
        label: 'Option 1.1',
        value: 1.1,
      }, {
        label: 'Option 1.2',
        value: 1.2,
      }],
    }, {
      label: 'Option 2',
      value: 2,
    }, {
      label: 'Option 3',
      value: 3,
    }, {
      label: 'Option 4',
      value: 4,
    }, {
      label: 'Option 5',
      value: 5,
    }, {
      label: 'Option 6',
      value: 6,
    }, {
      label: 'Option 7',
      value: 7,
    }, {
      label: 'Hello',
      value: 'hello',
    }],
    value: null,
  };

  onChangeProps = e => this.setState(e.target.value);

  onChange = e => {
    window.showAppInfo(e.target.value && typeof e.target.value === 'object' ? e.target.value[this.state.labelKey || 'label'] : e.target.value); // handle both array strings and array of objects
    this.setState({
      value: e.target.value,
    });
  };

  onTreeClick = e => {
    console.error('on tree click');
  };

  onUnlock = e => {
    window.showAppInfo('unlock icon');
    Application.showWarningDialog(
      'Unlock critical fields?',
      'This will unlock all critical fields and make them editable.',
      'Unlock', 'No', null,
      e => {
        this.setState({ locked: !this.state.locked });
      }
    );
  };

  render() {
    const dropdown = <Tree items={ITEMS} onClick={this.onTreeClick} data-preventmenuclose />;

    return (
      <Example {...this.props}>
        <Properties
          defaultProps={Select.defaultProps}
          onChange={this.onChangeProps}
          propTypes={Select.propTypes}
          propValues={this.state}
        >
          <Tip>Try setting <em>nestedKey</em> to <span className="string">children</span> to see nested options</Tip>
        </Properties>
        <Group>
          <Group title="Default">
            <Select
              label="Default"
              {...this.state}
              onChange={this.onChange}
              onUnlock={this.onUnlock}
            />
          </Group>
          <Group title="Custom dropdown">
            <Select
              data-preventmenuclose
              dropdown={dropdown}
              label="Custom dropdown"
              readOnly={false}
              showSearch={true}
              style={{ width: '100%' }}
            />
          </Group>
        </Group>
        <SourceCode querySelector=".select-example .core-select" />
      </Example>
    );
  }

}
